import PropTypes from 'prop-types';
import React from 'react';
import {
  ContentWrapper,
  LeftColumnWrapper,
  RightColumnWrapper,
  PageWrapper,
} from 'components/wrappers/pages';
import { connect } from 'react-redux';
import {
  onChangeKeyword,
  onClickInviteStaff,
  onClickExport,
  pageRequest,
  onClickRow,
  onClickAssignOutlet,
  onConfirmAssignOutlet,
  onCancelAssignOutlet,
  onSubmitForm,
  onCancelDeleteEmployee,
  onConfirmDeleteEmployee,
  onClickDeleteEmployee,
  onClickResendInvitation,
  onClickResendWithValidCaptcha,
  onCancelResend,
  hidePinRequiredModal,
  onClickAddStaffSlot,
  onChangeStatus,
  showDeactivateStaffModal,
  hideDeactivateStaffModal,
  onDeactivateStaff,
  onClickBtnReactivate,
  stopRenewalSlot,
  hideStopRenewalModal,
  onClickLinkStopRenewal,
  hidePaymentGatewayErrorModal,
} from 'actions/employees/staff';
import { formValueSelector, isDirty, getFormValues } from 'redux-form';
import { browserHistory } from 'react-router';
import { askConfirmAction } from 'actions/confirm-action';
import { push } from 'react-router-redux';
import ConfirmActionModal from 'components/ConfirmActionModal';
import PaymentGatewayErrorModal from 'components/PaymentGatewayErrorModal';
import withFeatureFlags from 'hocs/withFeatureFlags';
import isMokaposUser from 'selectors/isMokaposUser';
import _ from 'lodash';
import moment from 'moment';
import ActionBar from './ActionBar';
import StaffDetail from './StaffDetail';
import InactiveStaffList from './InactiveStaffList';
import EmptyState from './EmptyState';
import ResendCaptchaModal from './InactiveStaffList/ResendCaptchaModal';
import PinRequiredModal from './PinRequiredModal';
import StaffSlotInfo from './StaffSlotInfo';
import PurchaseStaffSlotModal from './PurchaseStaffSlotModal';
import ActiveStaffList from './ActiveStaffList';
import ReactivateStaffModal from './ReactivateStaffModal';
import ReactivateStaffNoSlotModal from './ReactivateStaffNoSlotModal';

class Staff extends React.Component {
  componentDidMount() {
    const {
      user,
      dispatch,
      searchFormValues,
      billingNotification,
    } = this.props;
    dispatch(
      pageRequest({
        user,
        billingNotification,
        status: searchFormValues ? searchFormValues.status : 'active',
      })
    );
    browserHistory.listenBefore(location => {
      // this is still hacky, don't copy paste this
      if (this.props.isDirtyStaff && !this.props.nextAction) {
        this.props.dispatch(askConfirmAction(push(location)));
        return false;
      }
    });
  }

  render() {
    const {
      openRightColumn,
      employees,
      submitting,
      employeeDetail,
      outlets,
      roles,
      user,
      pinRequiredModal,
      searchFormValues,
      showDeactivateStaffModal,
      slotDetail,
      showStopRenewalModal,
      showPaymentGatewayErrorModal,
      featurePrice,
      mokapayMode,
      isMokapos,
      pinAccessImprovement,
    } = this.props;
    const hasStaff = employees.length > 0;
    const hasRole = roles.length > 0;
    const showLoadingSpinner = submitting !== null;
    const showSlotInfo =
      !this._isAllOutletSetup() && !user.business.is_trial && user.is_owner;
    const deactivateBtnDisabled =
      user.is_manager &&
      (employeeDetail && employeeDetail.role.name === 'Administrator');

    const employeeDetails = pinAccessImprovement
      ? employees
          .filter(employee => !!employee.employee)
          .map(employee => employee.employee)
      : '';
    const employeePins = pinAccessImprovement
      ? employeeDetails
          .filter(employeeDetail => !!employeeDetail.pin)
          .map(employeeDetail => parseInt(employeeDetail.pin))
      : '';

    return (
      <PageWrapper>
        <ActionBar
          onChangeStatus={this._onChangeStatus}
          onChangeSearch={this._onChangeSearch}
          onClickExport={this._onClickExport}
          onClickAddStaffSlot={this._onClickAddStaffSlot}
          enableExportStaff={hasRole}
          isOwner={user.is_owner}
          isTrial={user.business.is_trial}
          isMokaposUser={isMokapos}
        />
        <ContentWrapper>
          <div style={{ height: '100%' }}>
            {searchFormValues &&
              searchFormValues.status === 'active' &&
              !showLoadingSpinner &&
              showSlotInfo &&
              hasStaff && (
                <StaffSlotInfo
                  strongText="You have 5 FREE employee slots"
                  text="per outlet. Please ensure your outlets are setup."
                />
              )}
            <LeftColumnWrapper openRightColumn={openRightColumn}>
              {!(hasRole && hasStaff) && (
                <EmptyState
                  hasRole={hasRole}
                  hasStaff={hasStaff}
                  canAccessRole={user.is_owner}
                  showLoadingSpinner={showLoadingSpinner}
                />
              )}
              {searchFormValues && searchFormValues.status !== 'active'
                ? hasRole &&
                  hasStaff &&
                  outlets.length > 0 && (
                    <InactiveStaffList
                      employees={this.props.employees}
                      onClickRow={this._onClickRow}
                      employeeDetail={employeeDetail}
                      outlets={outlets}
                      onClickReactivate={this._onClickReactivate}
                    />
                  )
                : hasRole &&
                  hasStaff &&
                  outlets.length > 0 && (
                    <ActiveStaffList
                      activeEmployees={this.props.employees}
                      onClickRow={this._onClickRow}
                      outlets={outlets}
                      onClickResendInvitation={this._onClickResendInvitation}
                      onClickInviteStaff={this._onClickInviteStaff}
                      openRightColumn={openRightColumn}
                      slotDetail={slotDetail}
                      mokapayMode={mokapayMode}
                    />
                  )}
            </LeftColumnWrapper>
            <RightColumnWrapper openRightColumn={openRightColumn}>
              {outlets.length > 0 && openRightColumn && (
                <StaffDetail
                  outlets={outlets}
                  roles={roles}
                  onSubmit={this._onSubmit}
                  onClickCancelAssignOutletModal={
                    this._onClickCancelAssignOutletModal
                  }
                  onClickConfirmAssignOutletModal={
                    this._onClickConfirmAssignOutletModal
                  }
                  onCancelDeleteEmployee={this._onCancelDeleteEmployee}
                  onConfirmDeleteEmployee={this._onConfirmDeleteEmployee}
                  onClickDeleteEmployee={this._onClickDeleteEmployee}
                  onClickFormAssignOutlet={this._onClickFormAssignOutlet}
                  showAssignOutletModal={this.props.showAssignOutletModal}
                  showEmployeeDeleteModal={this.props.showEmployeeDeleteModal}
                  employeeDetail={employeeDetail}
                  formValues={this.props.formValues}
                  selfView={
                    employeeDetail && this.props.user.id === employeeDetail.id
                  }
                  submitting={this.props.submitting}
                  searchFormValues={searchFormValues}
                  onClickDeactivateEmployee={this._onClickDeactivateEmployee}
                  showDeactivateStaffModal={showDeactivateStaffModal}
                  showDeactivateEmployeeErrorMessage={
                    this.props.showDeactivateEmployeeErrorMessage
                  }
                  onCancelDeactivateEmployee={this._onCancelDeactivateEmployee}
                  onConfirmDeactivateEmployee={
                    this._onConfirmDeactivateEmployee
                  }
                  slotDetail={slotDetail}
                  onClickReactivate={this._onClickReactivate}
                  deactivateDisabled={deactivateBtnDisabled}
                  onClickStopRenewal={this._onClickStopRenewal}
                  showLinkStopRenewal={
                    slotDetail && slotDetail.isRenewable
                      ? slotDetail.isRenewable && user.is_owner
                      : false
                  }
                  showStopRenewalModal={showStopRenewalModal}
                  onCancelStopRenewal={this._onCancelStopRenewal}
                  onProceedStopRenewal={this._onProceedStopRenewal}
                  employeePins={pinAccessImprovement ? employeePins : ''}
                />
              )}
            </RightColumnWrapper>
          </div>
        </ContentWrapper>
        <ConfirmActionModal />
        <ResendCaptchaModal
          show={this.props.showResendCaptchaModal}
          onClickWithValidCaptcha={this._onClickResendWithValidCaptcha}
          onCancel={this._onCancelResend}
        />
        <PinRequiredModal
          show={this.props.showPinRequiredModal}
          mode={this.props.employeeDetail ? 'edit' : 'create'}
          onConfirm={this._onConfirmPinRequiredModal}
          message={pinRequiredModal.message}
        />
        <PurchaseStaffSlotModal
          showPurchaseStaffSlotModal={this.props.showPurchaseStaffSlotModal}
        />
        <ReactivateStaffModal />
        <ReactivateStaffNoSlotModal />
        <PaymentGatewayErrorModal
          showModal={showPaymentGatewayErrorModal}
          onHide={this._onHidePaymentErrorModal}
          totalPrice={featurePrice && featurePrice.final_price}
        />
      </PageWrapper>
    );
  }

  _onSubmit = ({ values }) => {
    const {
      dispatch,
      employees,
      outlets,
      roles,
      user,
      slotDetail,
      file,
    } = this.props;
    // get related role for clevertap (and maybe other stuff)
    let role = {};
    // if the user edit his/her data
    // the role_id dropdown cannot be edited and the 'roles' value will not contain data related to his/her role
    // because administrator cannot see 'administator role' in endpoint /roles
    // so the role object will be get from 'employees' not the 'roles'
    if (user.id !== values.id) {
      roles.forEach(r => {
        if (`${r.id}` === `${values.role_id}`) {
          role = r;
        }
      });
    } else {
      employees.forEach(eSlot => {
        if (eSlot.employee && eSlot.employee.id === values.id) {
          role = eSlot.employee.role;
        }
      });
    }
    dispatch(
      onSubmitForm({
        values: { ...values, email: values.email.toLowerCase() },
        previousEmployees: employees,
        outlets,
        role,
        slotDetail,
        image: file,
      })
    );
  };

  _onChangeSearch = ({ trigger, keyword }) => {
    const { dispatch, user, searchFormValues } = this.props;
    if (trigger === 'keyword') {
      const payload = { keyword, user, active: false };

      if (searchFormValues && searchFormValues.status === 'active') {
        payload.active = true;
        if (keyword) {
          payload.occupied = true;
        }
      }
      dispatch(onChangeKeyword(payload));
    }
  };

  _onClickInviteStaff = ({ slot }) => {
    const { dispatch, isDirtyStaff } = this.props;
    if (isDirtyStaff) {
      dispatch(askConfirmAction(onClickInviteStaff({ slot })));
    } else {
      dispatch(onClickInviteStaff({ slot }));
    }
  };

  _onClickResendInvitation = ({ email }) => {
    const { dispatch } = this.props;
    dispatch(onClickResendInvitation({ email }));
  };

  _onClickExport = () => {
    const { dispatch, employees, user, searchFormValues } = this.props;
    let employeesToBeExported = employees;
    let status = 'Inactive';
    if (searchFormValues && searchFormValues.status === 'active') {
      // the json structure is different
      employeesToBeExported = _.map(
        _.filter(employees, 'employee'),
        'employee'
      );
      status = 'Active';
    }
    dispatch(onClickExport({ employees: employeesToBeExported, user, status }));
  };

  _onClickRow = ({ employee }) => {
    const { dispatch, isDirtyStaff, searchFormValues } = this.props;
    if (isDirtyStaff) {
      dispatch(
        askConfirmAction(
          onClickRow({
            employee,
            status: searchFormValues && searchFormValues.status,
          })
        )
      );
    } else {
      dispatch(
        onClickRow({
          employee,
          status: searchFormValues && searchFormValues.status,
        })
      );
    }
  };

  _onClickCancelAssignOutletModal = () => {
    this.props.dispatch(onCancelAssignOutlet());
  };

  _onClickConfirmAssignOutletModal = ({ assignedOutletIds }) => {
    this.props.dispatch(onConfirmAssignOutlet({ assignedOutletIds }));
  };

  _onClickFormAssignOutlet = () => {
    this.props.dispatch(onClickAssignOutlet());
  };

  _onCancelDeleteEmployee = () => {
    this.props.dispatch(onCancelDeleteEmployee());
  };

  _onConfirmDeleteEmployee = () => {
    const { employeeDetail, dispatch, employees } = this.props;
    dispatch(
      onConfirmDeleteEmployee({
        employee: employeeDetail,
        previousEmployees: employees,
      })
    );
  };

  _onClickDeleteEmployee = () => {
    this.props.dispatch(onClickDeleteEmployee());
  };

  _onCancelResend = () => {
    const { dispatch } = this.props;
    dispatch(onCancelResend());
  };

  _onClickResendWithValidCaptcha = () => {
    const { resendCaptchaEmail, dispatch } = this.props;
    dispatch(onClickResendWithValidCaptcha({ email: resendCaptchaEmail }));
  };

  _onConfirmPinRequiredModal = () => {
    const { dispatch } = this.props;
    dispatch(hidePinRequiredModal());
  };

  _onClickAddStaffSlot = () => {
    const { dispatch } = this.props;
    dispatch(onClickAddStaffSlot());
  };

  _onClickReactivate = (e, employee) => {
    const {
      dispatch,
      availableSlots,
      employeeDetail,
      user,
      formValues,
    } = this.props;
    if (employee) {
      // handle reactivate triggered by clicking button Reactivate on row list
      e.stopPropagation();
      dispatch(
        onClickBtnReactivate(employee, availableSlots, user, formValues)
      );
    } else {
      dispatch(
        onClickBtnReactivate(employeeDetail, availableSlots, user, formValues)
      );
    }
  };

  _onChangeStatus = status => {
    const { dispatch, user, searchFormValues } = this.props;
    const keyword = searchFormValues && searchFormValues.keyword;
    const payload = { keyword, status, user };

    if (status === 'active' && keyword) {
      payload.occupied = true;
    }
    dispatch(onChangeStatus(payload));
  };

  _onClickDeactivateEmployee = () => {
    this.props.dispatch(showDeactivateStaffModal());
  };

  _onConfirmDeactivateEmployee = () => {
    const { slotDetail, dispatch, employees } = this.props;
    dispatch(
      onDeactivateStaff({ slot: slotDetail, previousEmployees: employees })
    );
  };

  _onCancelDeactivateEmployee = () => {
    this.props.dispatch(hideDeactivateStaffModal());
  };

  _isAllOutletSetup = () => {
    const { user, outlets } = this.props;
    let usedOutletSlots = 0;
    let isAllSetup = false;
    if (outlets.length > 0) {
      outlets.forEach(outlet => {
        const endDate = moment(outlet.end_date);
        const todayDate = moment();
        if (endDate.isSameOrAfter(todayDate)) {
          usedOutletSlots++;
        }
      });
    }

    if (usedOutletSlots === user.business.outlet_slot) {
      isAllSetup = true;
    }
    return isAllSetup;
  };

  _onClickStopRenewal = () => {
    const { dispatch } = this.props;
    dispatch(onClickLinkStopRenewal());
  };

  _onCancelStopRenewal = () => {
    this.props.dispatch(hideStopRenewalModal());
  };

  _onProceedStopRenewal = () => {
    const { slotDetail, dispatch, employees } = this.props;
    dispatch(stopRenewalSlot(slotDetail, employees));
  };

  _onHidePaymentErrorModal = () => {
    this.props.dispatch(hidePaymentGatewayErrorModal());
  };
}

Staff.propTypes = {
  mokapayMode: PropTypes.bool,
};

Staff.defaultProps = {
  mokapayMode: false,
};

const selector = formValueSelector('staff');

function mapStateToProps(state, ownProps) {
  const {
    openRightColumn,
    employees,
    submitting,
    employeeDetail,
    outlets,
    showAssignOutletModal,
    roles,
    showEmployeeDeleteModal,
    showResendCaptchaModal,
    resendCaptchaEmail,
    canAccessRole,
    showPinRequiredModal,
    pinRequiredModal,
    showPurchaseStaffSlotModal,
    slotDetail,
    showDeactivateStaffModal,
    availableSlots,
    showStopRenewalModal,
    showPaymentGatewayErrorModal,
    showDeactivateEmployeeErrorMessage,
    featurePrice,
  } = state.employee.staff;
  const { user } = state.moka;
  const { is_mokapos_user: isMokapos } = state.moka.user.business;
  const { billingNotification } = state;
  const { file } = state.uploadImage.uploadImage;
  const { pinAccessImprovement } = ownProps;
  return {
    mokapayMode: !isMokaposUser(state),
    openRightColumn,
    employees,
    submitting,
    employeeDetail,
    user: {
      id: user.id,
      is_owner: user.is_owner,
      is_manager: user.is_manager,
      business: {
        name: user.business.name,
        is_trial: user.business.is_trial,
        outlet_slot: user.business.outlet_slot,
      },
    },
    outlets,
    showAssignOutletModal,
    showEmployeeDeleteModal,
    showDeactivateEmployeeErrorMessage,
    showResendCaptchaModal,
    resendCaptchaEmail,
    roles,
    formValues: {
      id: selector(state, 'id'),
      email: selector(state, 'email'),
      outlets: selector(state, 'outlets'),
      assign_pin: selector(state, 'assign_pin'),
      pin: selector(state, 'pin'),
      role_id: pinAccessImprovement ? selector(state, 'role_id') : '',
      is_enable_in_app_permission: pinAccessImprovement
        ? selector(state, 'is_enable_in_app_permission')
        : '',
    },
    isDirtyStaff: isDirty('staff')(state),
    nextAction: state.confirmAction.nextAction,
    canAccessRole,
    showPinRequiredModal,
    pinRequiredModal: {
      message: pinRequiredModal.message,
    },
    showPurchaseStaffSlotModal,
    searchFormValues: getFormValues('search')(state),
    slotDetail,
    showDeactivateStaffModal,
    availableSlots,
    billingNotification,
    showStopRenewalModal,
    showPaymentGatewayErrorModal,
    featurePrice,
    file,
    isMokapos,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

const connected = connect(
  mapStateToProps,
  mapDispatchToProps
)(Staff);

const mapFlagsToProps = flags => {
  return {
    pinAccessImprovement: flags.pinAccessImprovement,
  };
};

export default withFeatureFlags(mapFlagsToProps)(connected);
